var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsurionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 25,
    viewBox: "0 0 108 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1469 18.9515C24.1469 20.4282 25.3103 21.3104 26.4674 21.3104C27.8032 21.3104 28.7148 20.5345 28.7148 19.13C28.7148 17.1577 26.996 17.0184 25.271 16.5273C23.5183 16.0318 21.621 14.6666 21.621 11.8131C21.621 9.00413 23.7969 6.96484 26.4674 6.96484C28.2924 6.96484 29.6612 7.77288 30.646 9.21752L28.2532 11.5675C27.9755 10.8657 27.413 10.4095 26.7121 10.4095C25.7996 10.4095 25.3103 11.1122 25.3103 11.8131C25.3103 13.3622 27.2737 13.3291 29.171 14.0309C30.9576 14.6997 32.571 16.0711 32.571 19.0577C32.571 22.5747 30.0112 24.9648 26.4674 24.9648C22.8505 24.9648 20.4639 22.2952 20.4639 18.9515H24.1469Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2503 24.7538H46.3351V22.7475C45.5163 23.802 43.9119 24.9654 41.4485 24.9654C37.0306 24.9654 34.6074 22.3967 34.6074 17.7217V7.17969H38.528V16.8815C38.528 19.9734 39.844 21.3109 42.4092 21.3109C44.9797 21.3109 46.3351 19.4833 46.3351 16.8815V7.17969H50.2503V24.7538Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4639 7.17645H57.3567V9.00413C58.2049 7.87824 59.446 6.96484 61.9282 6.96484V10.6925H61.571C59.0978 10.6925 57.3567 12.4479 57.3567 15.0488V24.7506H53.4639V7.17645Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3214 0C67.75 0 68.8929 1.16161 68.8929 2.62857C68.8929 4.10089 67.75 5.25714 66.3214 5.25714C64.8929 5.25714 63.75 4.10089 63.75 2.62857C63.75 1.16161 64.8929 0 66.3214 0ZM64.4107 24.75H68.2321V7.22411H64.4107V24.75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7139 6.96484C84.9103 6.96484 88.7139 10.8327 88.7139 15.9648C88.7139 21.097 84.9103 24.9648 79.7139 24.9648C74.5174 24.9648 70.7139 21.097 70.7139 15.9648C70.7139 10.8327 74.5174 6.96484 79.7139 6.96484ZM79.7139 21.2363C82.7317 21.2363 84.7764 19.0247 84.7764 15.9648C84.7764 12.905 82.7317 10.6872 79.7139 10.6872C76.696 10.6872 74.6514 12.905 74.6514 15.9648C74.6514 19.0247 76.696 21.2363 79.7139 21.2363Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.357 24.7506H103.589V14.9809C103.589 12.6381 101.669 10.7256 99.3209 10.7256C96.9727 10.7256 95.053 12.6381 95.053 14.9809V24.7506H91.2852V14.9809C91.2852 10.5595 94.8923 6.96484 99.3209 6.96484C103.749 6.96484 107.357 10.5595 107.357 14.9809V24.7506Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94643 6.96484C4.00536 6.96484 0 10.9943 0 15.9648C0 20.9354 4.00536 24.9648 8.94643 24.9648C10.642 24.9648 12.525 24.4684 14.0482 22.747V24.7532H17.8929V15.9648C17.8929 10.9943 13.8875 6.96484 8.94643 6.96484ZM8.94643 21.097C6.12679 21.097 3.84464 18.7961 3.84464 15.9648C3.84464 13.1282 6.12679 10.8327 8.94643 10.8327C11.7607 10.8327 14.0482 13.1282 14.0482 15.9648C14.0482 18.7961 11.7607 21.097 8.94643 21.097Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsurionLogo);
export default __webpack_public_path__ + "static/media/AsurionLogo.c0344c65.svg";
export { ForwardRef as ReactComponent };